import { appClientConfig } from './appClientConfig';

export const BUILD_VERSION = appClientConfig.nextBuildNumber || '0';

export const APP_VERSION = `1.0.${BUILD_VERSION}`;
